"use strict";
exports.empty = {
    isUnsubscribed: true,
    next: function (value) { },
    error: function (err) { throw err; },
    complete: function () { }
};
//# sourceMappingURL=Observer.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/Observer.js
 ** module id = 84
 ** module chunks = 2
 **/